'use client';

import { SearchButtonComponent } from '@/layout/navbar/search-button-component';
import { useSearchDialogState } from '@veranda/shared/layout/search-dialog';

export function SearchButton({ className }: { className?: string }) {
  const { isOpen, setIsOpen } = useSearchDialogState();

  return (
    <SearchButtonComponent
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      className={className}
    />
  );
}
